import Vue from 'vue'
import Router from 'vue-router'
import Index from '../view/index'
import Home from '../view/home'
import ProductList from "../view/productList"
import ProductDetails from "../view/productDetails"
import Login from "../view/login"
import Cart from "../view/cart"
import Careers from "../view/careers"
import About from "../view/about"
import Contact from "../view/contact"
import Terms from "../view/terms"
import Privacy from "../view/privacy"
import Register from "../view/register"
import Account from "../view/account"
import Addresses from "../view/addresses"
import Purchase from "../view/purchase"
import Collections from "../view/collections"
import Category2 from "../view/category2List"
import ReturnsAndRefunds from "../view/returnsAndRefunds"
import Confirmation from "../view/confirmation"
import Search from '../view/search.vue'
import Order from '../view/order.vue'
import store from '../store';
import DriverApplication from '../view/driverApplication.vue'
import Profile from '../view/Profile'
import NotFound from "../view/404";
import LandingPage from '../view/landingPage.vue';
import ProductListHome from '../view/homeProductList'
import Checkout from '../view/checkout';
import GoogleAuth2 from '../view/googleauth2';
import google_auth_app from '../view/googleauth_app';
import WechatAuth2 from '../view/wechatauth2';
import FacebookAuth2 from '../view/facebookauth2';
import AppleAuth2 from '../view/appleauth2';
import facebook_auth_app from '../view/facebookauth_app';
import BindAccount from '../view/bindAccount';
import HelpSupport from '../view/helpSupport';
import DeliveryPolicy from '../view/deliveryPolicy';

// ------ ----- - - - -- - - - - ---
import Favorite from '../view/mobile/Favorite';
import Category from '../view/mobile/Category';
import mobileCart from '../view/mobile/mobileCart2';
import mobileCustomer from '../view/mobile/mobileCustomer';
import mobileLocations from '../view/mobile/mobileLocations';
import mobileEmail from '../view/mobile/mobileEmail';
import mobileCoupon from '../view/mobile/mobileCoupon';
import mobileOrder from '../view/mobile/mobileOrder';
import mobileAddress from '../view/mobile/mobileAddress';
import mobilePayment from '../view/mobile/mobilePayment';
import mobileReview from '../view/mobile/mobileReview';
import mobileFriends from '../view/mobile/mobileFriends';
import mobileViewAll from '../view/mobile/mobileViewAll';
import mobileSearch from '../view/mobile/mobileSearch';
import mobileUserinfo from '../view/mobile/mobileUserinfo';
import notifications from '../view/mobile/mobileNotifications';
import accountCancellation from '../view/mobile/mobileAccountCancellation';

Vue.use(Router);

async function validateToken(token) {
  //axios request to valida token
  return true
}

const routeToAccount = (to, from, next) => {
  // store.dispatch('addresses/fetchAddresses');
  // store.dispatch('addresses/fetchDefaultAddress');
  store.dispatch('orders/fetchOrderByTimeFrame', 3);
  // store.dispatch('auth/fetchCustomerInformation');
  next();
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [
        {
          path: '/',
          name: 'LandingPage',
          component: LandingPage,
        },
        // {
        //   path: '/referral/:idata',
        //   name: 'Referral',
        //   component: LandingPage,
        //   props: true,
        // },
        {
          path: '/home',
          name: 'Home',
          component: Home,
        },
        {
          path: '/google-auth2',
          name: 'GoogleAuth2',
          component: GoogleAuth2,
        },
        {
          path: '/google_auth_app',
          name: 'google_auth_app',
          component: google_auth_app,
        },
        {
          path: '/wechat-auth2',
          name: 'WechatAuth2',
          component: WechatAuth2,
        },
        {
          path: '/facebook-auth2',
          name: 'FacebookAuth2',
          component: FacebookAuth2,
        },
        {
          path: '/facebook_auth_app',
          name: 'facebook_auth_app',
          component: facebook_auth_app,
        },
        {
          path: '/apple-auth2',
          name: 'AppleAuth2',
          component: AppleAuth2,
        },
        {
          path: '/bindaccount',
          name: 'BindAccount',
          component: BindAccount,
        },
        // {
        //   path: '/collections/:group',
        //   name: 'productList',
        //   component: ProductList,
        //   props: true,
        // },
        {
          path: '/collections',
          name: 'productList',
          component: ProductList,
          // props: true
        },
        // ProductListHome, ProductList
        {
          path: '/productDetails',
          name: 'productDetails',
          component: ProductDetails,
          props: true,
        }, {
          path: '/login',
          name: 'login',
          // beforeEnter: guard,
          component: Login,
        }, {
          path: '/cart',
          name: 'cart',
          component: Cart,
        }, {
          path: '/about-us',
          name: 'about',
          component: About,
        }, {
          path: '/contact-us',
          name: 'contact',
          component: Contact,
        }, {
          path: '/returns-and-refunds',
          name: 'returns-and-refunds',
          component: ReturnsAndRefunds,
        }, {
          path: '/terms-of-service',
          name: 'terms',
          component: Terms,
        }, {
          path: '/privacy',
          name: 'privacy',
          component: Privacy,
        }, {
          path: '/register',
          name: 'register',
          component: Register,
        }, {
          path: '/careers',
          name: 'careers',
          component: Careers,
        }, {
          path: '/account',
          name: 'account',
          component: Profile,
          beforeEnter: routeToAccount,
        }, {
          path: '/addresses',
          name: 'addresses',
          component: Addresses,
        }, {
          path: '/purchase',
          name: 'purchase',
          component: Checkout,
        },
        {
          path: '/confirmation',
          name: 'confirmation',
          component: Confirmation,
        },
        {
          path: '/order/:order_id',
          name: 'order',
          component: Order,
        },
        // {
        //   path: '/collections',
        //   name: 'collections',
        //   component: ProductListHome,
        //   props: true
        // },
        {
          path: '/search',
          name: 'search',
          component: Search,
        }, {
          path: '/category2/:cat2',
          name: 'category2',
          component: Category2,
          props: true,
        }, {
          path: '/driverapplication',
          name: 'driverapplication',
          component: DriverApplication,
          props: true,
        }, {
          path: '/help-and-support',
          name: 'helpSupport',
          component: HelpSupport,
          props: true,
        }, {
          path: '/delivery-policy',
          name: 'delivery-policy',
          component: DeliveryPolicy,
          props: true,
        },
        //=-------- -- ------ - --
        {
          path: '/favorite',
          name: 'Favorite',
          component: Favorite,
        }, {
          path: '/category',
          name: 'Category',
          component: Category,
        }, {
          path: '/mobileCart',
          name: 'mobileCart',
          component: mobileCart,
        }, {
          path: '/mobileCustomer',
          name: 'mobileCustomer',
          component: mobileCustomer,
        },{
          path: '/mobileLocations',
          name: 'mobileLocations',
          component: mobileLocations,
        },{
          path: '/mobileEmail',
          name: 'mobileEmail',
          component: mobileEmail,
        },{
          path: '/mobileCoupon',
          name: 'mobileCoupon',
          component: mobileCoupon,
        },{
          path: '/mobileOrder',
          name: 'mobileOrder',
          component: mobileOrder,
        },{
          path: '/mobileAddress',
          name: 'mobileAddress',
          component: mobileAddress,
        },{
          path: '/mobilePayment',
          name: 'mobilePayment',
          component: mobilePayment,
        },{
          path: '/mobileReview',
          name: 'mobileReview',
          component: mobileReview,
        },{
          path: '/mobileFriends',
          name: 'mobileFriends',
          component: mobileFriends,
        },{
          path: '/mobileViewAll',
          name: 'mobileViewAll',
          component: mobileViewAll,
        },{
          path: '/mobileSearch',
          name: 'mobileSearch',
          component: mobileSearch,
        },{
          path: '/mobileUserinfo',
          name: 'mobileUserinfo',
          component: mobileUserinfo,
        },{
          path: '/notifications',
          name: 'notifications',
          component: notifications,
        },{
          path: '/accountCancellation',
          name: 'accountCancellation',
          component: accountCancellation,
        },
        {path: '*', component: NotFound}
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return {x: 0, y: 0}
  },
})

router.beforeEach((to, from, next) => {
  next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js